import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.scss';


class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.onChange) {
      this.props.onChange(!this.props.checked);
    }
  }

  render() {
    const { checked, disabled } = this.props;
    const className = classNames(styles.checkbox, {
      [styles.checked]: checked,
      [styles.disabled]: disabled
    });

    return (
      <span className={className} onClick={this.onClick}>
        <span />
      </span>
    );
  }
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export default Checkbox;



// WEBPACK FOOTER //
// src/components/shared/Checkbox/index.jsx